
import React, { useState, useEffect } from "react"
import 'react-querybuilder/dist/query-builder.css';
import "./siteUrl.css"
import {
  Alert,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
} from "reactstrap"


import { connect } from "react-redux"

import { setBreadcrumbItems } from "../../store/actions"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { Link, useParams } from "react-router-dom";
import IndividualReports from "./individualReports";
import ScanNameReports from "./scanNameReports";
import { PAGEPATHS } from "components/Common/Constant";

const ComplianceTable = props => {
  document.title = "Add Site URL's"
  const [iframeUrl, setIframeUrl] = useState("");
  // const scanId = sessionStorage.getItem('scanId')
  const { scanId } = useParams();
  const [selectedReportTitle, setSelectedReportTitle] = useState("");
  const [reportsData, setReportsData] = useState([]);
  const [indiReportsData, setIndiReportsData] = useState([]);
  const [showIndividual, setShowIndividual] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log(scanId, "scanIdscanId")
  useEffect(() => {
    props.setBreadcrumbItems("Compliance Page", [])
  })
  // useEffect(() => {
  //   axios.get("http://localhost:5000/api/metabase/dashboard-url") // your Node.js backend
  //     .then((res) => {
  //       setIframeUrl(res.data.iframeUrl);
  //     })
  //     .catch((err) => {
  //       console.error("Failed to load dashboard", err);
  //     });
  // }, []);


  const getIframeList = async () => {
    try {
      const response = await axiosInstance.post(ApiNames.COMPLIANCE_TABLE_LIST);
      setIframeUrl(response.data.data);
      console.log(response, "response");



    } catch (e) {
      console.error(e);
    }
  };

  const getReportList = async () => {
    setLoading(true)
    try {
      const response = await axiosInstance.post(ApiNames.COMPLIANCE_REPORT_LIST);
      if (response.status) {
        setReportsData(response.data.data);
      }




    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    getReportList()
    // getIframeList()
  }, []);
  const handleIndividualReport = async (data) => {
    setSelectedReportTitle(data)
    setShowIndividual(true)

  }

  return (
    <React.Fragment>
      {showIndividual
        ?
        <ScanNameReports selectedReports={indiReportsData} setShowIndividual={setShowIndividual} selectedRepoortTitle={selectedReportTitle} scanId={scanId} />


        :

        <Row className="justify-center">
          <Col lg={12}>
            <Card>
              <CardBody>

                {loading ?

                  <>
                    <h4>Loading...</h4>
                  </>
                  : <>
                    {reportsData.map((data, index) => (
                      <Link key={index} to={`${PAGEPATHS.ComplianceDashboard}/${scanId}/${data.replace(/ /g, "_")}`}>
                        <Alert variant="dark">
                          {data}
                        </Alert>
                      </Link>
                    ))}

                  </>
                }




                {/* <div>
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          frameBorder="0"
          width="100%"
          height="800"
          allowTransparency
          title="Metabase Dashboard"
        />
      ) : (
        <p>Loading dashboard...</p>
      )}
    </div> */}




              </CardBody>
            </Card>
          </Col>
        </Row>

      }
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(ComplianceTable)
